webpackJsonp([12],{

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_revieve_try_on__ = __webpack_require__(19);


__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-revieve-full-look').on('click', function (e) {
    e.preventDefault();
    Revieve.API.show();
    logEngagement(window.location.href, 'VTO', 'Open');
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_revieve_try_on__["a" /* revieveAddToBag */])();
});

/***/ })

},[204]);


// WEBPACK FOOTER //
// dist/landing.js